import type { ReactNode } from 'react';

export const symbol_scan_delete: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-820v186-186 680-11.5 11.5-680Zm0 740q-24 0-42-18t-18-42v-680q0-24 18-42t42-18h336q12.44 0 23.72 5T599-862l183 183q8 8 13 19.28 5 11.28 5 23.72v182q0 13-8.68 21-8.67 8-21.5 8-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-179H611q-24.75 0-42.37-17.63Q551-669.25 551-694v-126H220v680h321q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32Q553.75-80 541-80H220Zm500-117-63 62q-9 8-21.1 8.5-12.1.5-20.9-8.5-9-9-9-21t9-21l63-63-63-63q-9-9-9-21t9-21q9-9 21-9t21 9l63 63 63-63q9-9 21-9t21 9q9 9 8.5 21t-8.5 21l-62 63 62 63q8 9 8.5 21.1.5 12.1-8.5 20.9-9 9-21 8.5t-21-8.5l-63-62Z"
		/>
	</svg>
);
